import React from 'react'
import { Table, Card } from 'antd'
import { QrCodeState } from 'Types/QrCode.d'

interface SheetDataTableProps {
  state: QrCodeState
  onTableChange: (pagination: any) => void
}

const SheetDataTable: React.FC<SheetDataTableProps> = ({
  state,
  onTableChange
}) => {
  if (!state.sheetData.length) return null

  return (
    <Card 
      title={<span className="text-lg font-semibold">Loaded Sheet Data</span>} 
      bordered={false} 
      className="mt-6 shadow-md"
    >
      <Table
        columns={state.columns}
        dataSource={state.sheetData}
        scroll={{ x: true }}
        pagination={state.pagination}
        onChange={onTableChange}
        size="middle"
        bordered
        className="print-friendly-table"
      />
    </Card>
  )
}

export default SheetDataTable 